export default function News() {
  const news: Array<{
    image: string;
    category: string;
    date: string;
    title: string;
    description: string;
  }> = [];

  return (
    <section id="berita" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Berita & Aktiviti</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ikuti perkembangan terkini dan aktiviti madrasah kami
          </p>
        </div>

        {news.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 bg-emerald-50 rounded-full">
              <i className="ri-newspaper-line text-5xl text-emerald-700"></i>
            </div>
            <p className="text-xl text-gray-500">Tiada berita tersedia buat masa ini</p>
          </div>
        ) : (
          <>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {news.map((item, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all overflow-hidden group cursor-pointer">
                  <div className="relative overflow-hidden h-56">
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-emerald-700 text-white px-4 py-2 rounded-full text-sm font-semibold">
                        {item.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-gray-500 text-sm mb-3">
                      <i className="ri-calendar-line"></i>
                      <span>{item.date}</span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-emerald-900 mb-3 group-hover:text-emerald-700 transition-colors">
                      {item.title}
                    </h3>
                    
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {item.description}
                    </p>
                    
                    <button className="text-emerald-700 font-semibold flex items-center gap-2 hover:gap-3 transition-all cursor-pointer whitespace-nowrap">
                      Baca Selanjutnya
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <button className="bg-emerald-700 text-white px-8 py-4 rounded-full font-semibold hover:bg-emerald-800 transition-colors shadow-lg cursor-pointer whitespace-nowrap">
                Lihat Semua Berita
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
